import useAgentData from '~/client/hooks/useAgentData';
import useAccountPopoverStore from '~/client/store/useAccountPopoverStore';

const usePopover = () => {
  const { isMobile } = useAgentData();
  const { activePopover, isDisplayed, dismissPopover } =
    useAccountPopoverStore();
  const hasPopover = !isMobile && isDisplayed && !!activePopover;
  const popoverModule = hasPopover && activePopover;
  const handlePopoverClose = () => {
    if (activePopover === 'socials') {
      return;
    }
    dismissPopover(true);
  };
  return { popoverModule, handlePopoverClose };
};

export default usePopover;
